import ApiService from "@/core/services/api.service";
import querystring from "querystring";
import { responseError } from '@/core/mixin/shared'

const BASE = "report";

export const MODULE_NAME = `reportModule`;
export const BASE_URL = `api/institutions`;
export const INSTITUTIONS_URL = `api/reports/institutions`;
export const BRANCHES_URL = `api/reports/branches`;
export const LOADING = `${BASE}/LOADING`;
export const ERROR = `${BASE}/ERROR`;
export const SUCCESS = `${BASE}/SUCCESS`;
export const INSTITUTIONS = `${BASE}/INSTITUTIONS`;
export const BRANCHES = `${BASE}/BRANCHES`;

export const SET_LOADING = `${BASE}/M/LOADING`;
export const SET_ERROR = `${BASE}/M/ERROR`;
export const SET_SUCCESS = `${BASE}/M/SUCCESS`;
export const SET_INSTITUTIONS = `${BASE}/M/INSTITUTIONS`;
export const SET_BRANCHES = `${BASE}/M/BRANCHES`;


export const RESET_VALUES = `${BASE}/M/RESET_VALUES`;

// ACTIONS
export const GET_INSTITUTIONS = `${BASE}/GET_INSTITUTIONS`;
export const GET_BRANCHES = `${BASE}/GET_BRANCHES`;

const state = {
    items: null,
    institutions: null,
    branches: null,
    loading: false,
    error: null,
    success: null
};

const getters = {
    [LOADING]: state => {
        return state.loading;
    },
    [ERROR]: state => {
        return state.error;
    },
    [SUCCESS]: state => {
        return state.success;
    },
    [INSTITUTIONS]: state => {
        return state.institutions;
    },
    [BRANCHES]: state => {
        return state.branches;
    }
};

const mutations = {
    [SET_LOADING]: (state, payload) => {
        state.loading = payload;
    },
    [SET_ERROR]: (state, payload) => {
        state.error = responseError(payload);
    },
    [SET_SUCCESS]: (state, payload) => {
        state.success = payload;
    },
    [SET_INSTITUTIONS]: (state, payload) => {
        state.institutions = payload;
    },
    [SET_BRANCHES]: (state, payload) => {
        state.branches = payload;
    },
    [RESET_VALUES]: state => {
        state.success = null;
        state.error = null;
        state.loading = false;
    }
};

const actions = {
  [GET_INSTITUTIONS]: (context, payload) => {
        let url = INSTITUTIONS_URL;
        let filters = payload.filters;
        context.commit(SET_LOADING, true);
        context.commit(SET_ERROR, null);
        if (filters) {
            url = `${url}?` + querystring.stringify(filters);
        }
        return ApiService.get(url)
            .then(response => {
                context.commit(SET_LOADING, false);
                context.commit(SET_INSTITUTIONS, response.data);
            })
            .catch(error => {
                context.commit(SET_ERROR, error);
            });
    },

    [GET_BRANCHES]: (context, payload) => {
        let url = BRANCHES_URL;
        let filters = payload.filters;
        context.commit(SET_LOADING, true);
        context.commit(SET_ERROR, null);
        if (filters) {
            url = `${url}?` + querystring.stringify(filters);
        }
        return ApiService.get(url)
            .then(response => {
                context.commit(SET_LOADING, false);
                context.commit(SET_BRANCHES, response.data);
            })
            .catch(error => {
                context.commit(SET_ERROR, error);
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
